<template>
    <div :class="['home-server', { 'scroll-hide': !store.showBuoy }]" @click="goServer"><img src="@/assets/img/new-home/cusomer.png" /></div>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
const store = useBaseStore()

const goServer = () => {
    window.open('https://m.me/playtok1')
}
</script>
<style lang="scss" scoped>
.home-server {
    position: fixed;
    right: 20px;
    bottom: calc(var(--footer-height) + 30px);
    width: 80px;
    height: 80px;
    transition: all 0.3s ease;
    transform: translate3d(0, 0, 0);
}
.scroll-hide {
    &.home-server {
        transform: translate3d(130%, 0, 0);

        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
